<mat-form-field appearance="outline" class="pt-1 no-padding w-full">
    <mat-label>Assisted Search</mat-label>
    <input matInput type="text"
        #inputElement
        class="truncate"
        [(ngModel)]="searchText"
        [placeholder]="animatedText"
        (focus)="onFocus()"
        (blur)="onBlur()"
        (input)="handleUserTyping()"
        (keypress)="restrictQuotes($event)"
        (paste)="sanitizePaste($event)"
        (keydown.enter)="onEnterPress()">

    <img *ngIf="isShowLogo && !searchText" class="assisted-logo" matPrefix src="../../../../../assets/icons/ai-icon.png" alt="AI" />
    <ng-container matSuffix>
        <ng-container *ngTemplateOutlet="commonButtons"></ng-container>
    </ng-container>
</mat-form-field>
<ng-template #overlayTemplate>
    <div class="overlay-container w-full flex p-2 absolute"
        (focusout)="handleFocusOut()" (click)="$event.stopPropagation()">
        <textarea [(ngModel)]="searchText" class="expanded-textarea w-full font-light p-1"
            (input)="handleOverlayTyping()" (keypress)="restrictQuotes($event)" (paste)="sanitizePaste($event)" (keydown.enter)="onEnterPress($event)" autofocus> </textarea>
        <div class="flex">
            <ng-container *ngTemplateOutlet="commonButtons"></ng-container>
        </div>
    </div>
</ng-template>


<ng-template #commonButtons>
    <button *ngIf="searchText && !isLoading" matIconButton aria-label="Clear" (click)="clearText()">
        <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
    </button>
    <button *ngIf="searchText && !isLoading" type="button" matSuffix mat-mini-fab aria-label="Search" (click)="triggerSearch()" class="mat-primary" [class.pulse-button]="isQueryUnsearched()">
        <fa-icon class="si-icon" [icon]="['fal', 'magnifying-glass']"></fa-icon>
    </button>
    <button *ngIf="searchText && isLoading" matIconButton>
        <mat-spinner [diameter]="24" [strokeWidth]="2"></mat-spinner>
    </button>
</ng-template>
